import { IKeypadButtonProps } from "./keypad-button.props";
const KeyPadButton = ({
  onClick,
  value,
  label,
  customClass,
  disabled,
  testId,
  icon
}: IKeypadButtonProps) => {
  return (
    <button
      className={customClass}
      onClick={onClick}
      data-value={value}
      disabled={disabled}
      data-testid={testId}
    >
      {icon ? <div className={`g-icon-${icon}`}></div> : label}
    </button>
  );
};
export default KeyPadButton;